import React from 'react';
import { renderField, renderSelectCustom } from '../Utils/renderField/renderField';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { validate, validators } from 'validate-redux-form';


let FrmCoupon = (props) => {
    const { handleSubmit } = props;

    return (
        <form onSubmit={handleSubmit} id="setCouponCode" className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
            <div className="form-group">
                <label>Ingrese el código del cupón</label>
                <Field name="code" component={renderField} autofocus type="text" className="form-control"/>
            </div>
        </form>
    );
}

FrmCoupon = reduxForm({
    form: 'frmModalCoupon',
    validate: data => {
         return validate(data, {
             'code': validators.exists()('Campo requerido.'),
        })
    }
 })(FrmCoupon);

export default FrmCoupon;
